import { FILTER_ENABLED_SLUGS } from './constants';
import type { FilterEnabledSlugs } from './types';

export const isFilterEnabledSlug = (slug: string): slug is FilterEnabledSlugs =>
  FILTER_ENABLED_SLUGS.includes(slug as FilterEnabledSlugs);
